import CollectionsIcon from '@mui/icons-material/Collections';
import { useState } from 'react';

import { SingleIconButton } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import FotosEntradaSubidaOTModal from './FotosEntradaSubidaOTModal';
import FotosSalidaSubidaOTModal from './FotosSalidaSubidaOTModal';

export type ActivacionOTCellOTSubidaProps = {
  ordenTrabajo: OrdenTrabajo;
};

const ActivacionOTCellOTSubida: React.FC<ActivacionOTCellOTSubidaProps> = ({
  ordenTrabajo,
}) => {
  ///* local state ------------
  const [isOpenFotosEntradaModal, setIsOpenFotosEntradaModal] = useState(false);
  const [isOpenFotosSalidaModal, setIsOpenFotosSalidaModal] = useState(false);

  return (
    <>
      <SingleIconButton
        startIcon={<CollectionsIcon />}
        color="info"
        label={'Ver Fotos Entrada'}
        onClick={() => {
          setIsOpenFotosEntradaModal(true);
        }}
      />

      <SingleIconButton
        startIcon={<CollectionsIcon />}
        color="primary"
        label={'Ver Fotos Salida'}
        onClick={() => {
          setIsOpenFotosSalidaModal(true);
        }}
      />

      {/* =========== MODALS =========== */}
      <FotosEntradaSubidaOTModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosEntradaModal}
        onClose={() => {
          setIsOpenFotosEntradaModal(false);
        }}
      />

      <FotosSalidaSubidaOTModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosSalidaModal}
        onClose={() => {
          setIsOpenFotosSalidaModal(false);
        }}
      />
    </>
  );
};

export default ActivacionOTCellOTSubida;
